
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.06","height":"12.06"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_34339","data-name":"Group 34339","transform":"translate(-110.97 -447.969)"}},[_c('circle',{attrs:{"id":"Ellipse_441","data-name":"Ellipse 441","cx":"5.53","cy":"5.53","r":"5.53","transform":"translate(111.47 448.469)","fill":"none","stroke":"#5a677d","stroke-width":"1"}}),_c('path',{attrs:{"id":"Polygon_7","data-name":"Polygon 7","d":"M2.076.678a.5.5 0 01.848 0l1.6 2.557A.5.5 0 014.1 4H.9a.5.5 0 01-.424-.765z","transform":"rotate(90 -166 285.5)","fill":"#5a677d"}})])])
          )
        }
      }
    